/* eslint-disable no-undef */
import {Dimensions, Platform} from 'react-native';
import {responsiveHeight, responsiveWidth} from '../components/customResponsiveDimension';
import Toast from '../components/Toast';
import {ACCID, ACCNAME, ACCNUMB, ACCOUNT_TYPE, ACHACN_ID, AMOUNT_WITHOUT_PROMO, BENEID, BILLER_NAME, CLOSE_TICKER_FLAG, CLOSE_TICKER_LOGIN_FLAG, CUST_CAT_ID, CSRF_TOKEN, CUST_ID, FIRST_NAME, LOGIN_ID, NOTIFICATION_COUNT, PREF_AUTH_TOKEN, PREF_CURRENCY_CON, PREF_FIRST_NAME, PRIMARY_DETAIL, PROMO_CODE, PROMO_DETAIL, PWORD, removePrefData, SESSION_ID, SIGNIN_OTP_VERIFIED, SIGNUP_OTP_VERIFIED, TRANSFER_TYPE, USER_DETAIL, USER_ID, VALIDATION_TRANSACTION_FLAG, YODLEE_INFO, ACCOUNT_REDIRECTION_FLAG, ACH_REVERIFY, CUST_RISK_RATE_FLAG, FIREFOX_INFO, COMMWITHOUTPROMO, SSO_REG_DATA, IDENTIFIER, COUPON_PAISE, PROMO_CAP_FLAG, MAX_FC_AMT_CAP, OLD_EXCHANGE_RATE, PROMO_APPLIED, FINAL_EXCHANGE_RATE, MEMBERSHIP_APPLIED, CONVERSION_MODE, PROMO_BENEFIT, UK_CONSENT_FLAG, LN_DOC_INFO} from '../storage/preferenceStorage';
import {getNativeDeviceInfo} from './deviceInfo';
import {getDomainURL} from './helperUtils';
import {encodeBase64} from './jsEncrypt';
import dayjs from 'dayjs';
import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';
import forge from "node-forge";
import { Linking } from 'react-native';
import SafariView from '../components/openUrlSupport';
import { downloadReceipt } from '../components/downloadPermissionUtils.js';
import { base64images } from '../constants/displayConstants.js';
import { receiptTemplate } from '../pages/my_transaction/newReceiptFormat';

const NewToast = new Toast();

export const widthInPercentage = dimensionWidth => {
  if (Platform.OS === 'web') {
    return `${dimensionWidth}%`;
  }
  return responsiveWidth(dimensionWidth);
};
export const heightInPercentage = dimensionHeight => {
  if (Platform.OS === 'web') {
    return `${dimensionHeight}%`;
  }
  return responsiveHeight(dimensionHeight);
};

export const fontInPercentage = dimensionSize => {
  return dimensionSize;
};

export function getResponsiveStyle(styleName, measure) {
  const styleName_Width = `${styleName}_${measure}`;
  return styleName_Width;
}

export const getWidth = () => {
  const {width} = Dimensions.get('window');
  return width;
};

export const percentageOf = (width, requiredWidth) => {
  return width * (requiredWidth / 100);
};

export const getHeight = () => {
  const {height} = Dimensions.get('window');
  return height;
};

export const showToast = (message, duration) => NewToast.showToast(message, duration);

export const getScrollbarWidth = () => {
  if (Platform.OS !== 'web') return null;
  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
};

export const getRegex = (text, regex, prevValue) => {
  let isChecked;
  if (text === '') {
    // JUST BLANK
  } else if (!text.match(regex)) {
    isChecked = true;
  }
  return isChecked ? prevValue : text;
};

export const clearStorage = async pageName => {
  await removePrefData(CUST_ID);
  await removePrefData(PREF_AUTH_TOKEN);

  if (Platform.OS === 'web') {
    await removePrefData(USER_ID);
  }

  //  removePrefData(RESCOUNTRYID);
  await removePrefData(SESSION_ID);
  //removePrefData('login_id');
  await removePrefData(FIRST_NAME);
  //removePrefData('user_detail');
  await removePrefData(ACCOUNT_TYPE);
  await removePrefData(PREF_CURRENCY_CON);
  await removePrefData(SIGNIN_OTP_VERIFIED);
  await removePrefData(SIGNUP_OTP_VERIFIED);
  await removePrefData(PREF_FIRST_NAME);
  await removePrefData(PROMO_CODE);
  await removePrefData(BENEID);
  // await removePrefData(ACCNUMB);
  await removePrefData(ACCNAME);
  await removePrefData(ACCID);
  await removePrefData(NOTIFICATION_COUNT);
  await removePrefData(USER_DETAIL);
  await removePrefData(PROMO_CODE);
  await removePrefData(PROMO_DETAIL);
  await removePrefData(LOGIN_ID);
  await removePrefData(TRANSFER_TYPE);
  // removePrefData(PREF_EMAIL_ID);
  await removePrefData(CUST_CAT_ID);
  await removePrefData(PWORD);
  await removePrefData(YODLEE_INFO);
  await removePrefData(PRIMARY_DETAIL);
  await removePrefData(TRANSFER_TYPE);
  await removePrefData(ACHACN_ID);
  await removePrefData(VALIDATION_TRANSACTION_FLAG);
  await removePrefData(BILLER_NAME);
  await removePrefData(AMOUNT_WITHOUT_PROMO);
  await removePrefData(CLOSE_TICKER_FLAG);
  await removePrefData(CLOSE_TICKER_LOGIN_FLAG);
  await removePrefData(ACCOUNT_REDIRECTION_FLAG);
  await removePrefData(ACH_REVERIFY);
  await removePrefData(CUST_RISK_RATE_FLAG);
  // await removePrefData(DEFAULT_PRODID);
  removeSession(SESSION_ID);
  // await removePrefData(TICKER_TEXT);
  await removePrefData(CSRF_TOKEN);
  // removePrefData(CUSTTYPE);
  await removePrefData(FIREFOX_INFO);
  await removePrefData(COMMWITHOUTPROMO);
  await removePrefData(SSO_REG_DATA);
  await removePrefData(IDENTIFIER);
  await removePrefData(COUPON_PAISE);
  await removePrefData(PROMO_CAP_FLAG);
  await removePrefData(MAX_FC_AMT_CAP);
  await removePrefData(OLD_EXCHANGE_RATE);
  await removePrefData(PROMO_APPLIED);
  await removePrefData(FINAL_EXCHANGE_RATE);
  await removePrefData(MEMBERSHIP_APPLIED);
  await removePrefData(CONVERSION_MODE);
  await removePrefData(PROMO_BENEFIT);
  await removePrefData(UK_CONSENT_FLAG);
  await removePrefData(LN_DOC_INFO);
};

export const callLogout = (loginId, custId, countryId, email, token) => {
  const emailId = encodeBase64(email);
  const apiUrl = getDomainURL(countryId);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({loginId, custId, countryId, emailId})
  };
  fetch(`${apiUrl}/signup/logoutApplication`, requestOptions)
    .then(response => response.json())
    .then(data => {
      clearStorage('apputil.js');
    });
};

export const getDeviceInfo = () => {
  let form;

  form = getNativeDeviceInfo();

  return form;
};

export const getURLPathname = () => {
  var pageURL = window.location.href;
  var lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1);

  return lastURLSegment;
};

export const isSafariBrowser = () => {
  if (Platform.OS === 'web') {
    var isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function(p) {
        return p.toString() === '[object SafariRemoteNotification]';
      })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    return isSafari;
  }
};

export const absolutePositionFooterStyle = () => {
  let marginTopofFooter = '';
  if (Dimensions.get('window').width < 768) {
    marginTopofFooter = Dimensions.get('window').height - 90;
  } else {
    marginTopofFooter = Dimensions.get('window').height - 50;
  }

  let footerStyle = {
    top: marginTopofFooter,
    position: 'absolute',
    width: '100%'
  };

  return footerStyle;
};

export const footerStyle = () => {
  let footerStyle = {
    marginTop: '4%'
  };
  return footerStyle;
};

export const browserSupport = userAgent => {
  return !(userAgent.toLowerCase().indexOf('msie') > -1 || userAgent.toLowerCase().indexOf('msie ') > -1 || userAgent.indexOf('Trident/') > -1);
};

export const compareHeightTorenderFooter = viewHeight => {
  let extraHeightofFooter = '';
  if (Dimensions.get('window').width < 768) {
    extraHeightofFooter = 90;
  } else {
    extraHeightofFooter = 50;
  }
  if (Dimensions.get('window').height > viewHeight + extraHeightofFooter) {
    FooterStyle = absolutePositionFooterStyle();
  } else {
    FooterStyle = footerStyle();
  }

  return FooterStyle;
};

export const storeSession = (key, value) => {
  if (Platform.OS === 'web') {
    sessionStorage.setItem(key, value);
  }
};

export const getSessionValue = key => {
  if (Platform.OS === 'web') {
    sessionStorage.getItem(key);
  }
};

export const removeSession = key => {
  if (Platform.OS === 'web') {
    sessionStorage.removeItem(key);
  }
};

export const checkZeroInDecimal = num => {
  var deci = num - Math.floor(num) !== 0;
  if (deci) {
    zero = num.toString().split('.');

    if (zero[1] === '00') {
      return num;
    } else {
      return num.toFixed(2);
    }
  } else {
    return num;
  }
};

export const mobileCheck = function() {
  if (Platform.OS === 'web') {
    let check = false;
    (function(a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }
};

export const transactionParams = () => {
  return {
    acceptReqAmount: undefined,
    conversionMode: undefined,
    endDate: undefined,
    fromPage: undefined,
    gstNumber: undefined,
    messageError: undefined,
    noOfTrans: undefined,
    promoCodeData: undefined,
    selectedFrequency: undefined,
    selectedMethod: undefined,
    selectedPurposeForTransfer: undefined,
    selectedRate: undefined,
    selectedRecipientAccount: undefined,
    selectedRecurringTab: undefined,
    selectedSendLaterTab: undefined,
    selectedSenderAccount: undefined,
    selectedSourceOfFunds: undefined,
    selectedSubPurposeCode: undefined,
    senderAmt: undefined,
    sourceOfFundText: undefined,
    startDate: undefined,

    actDateVal: undefined,
    clearingCode: undefined,
    corrBankAddress: undefined,
    corrBankName: undefined,
    corrBankaccNumber: undefined,
    credidate: undefined,
    expectedDate: undefined,
    from: undefined,
    recAccNum: undefined,
    recBankName: undefined,
    receiverAmt: undefined,
    recipientName: undefined,
    sendAccNum: undefined,
    senderAccName: undefined,
    senderName: undefined,
    sourceAccount: undefined,
    swiftCode: undefined,
    trackingNo: undefined
  };
};

export const paybillParams = () => {
  return {
    confirmData: undefined,
    estiDays: undefined,
    from: undefined,
    receiverAmt: undefined,
    senderAccName: undefined,
    senderName: undefined,
    trackingNo: undefined
  };
};

export const GetBGTimer = () => {
  const getCurrentTimeBackground = dayjs(new Date(), 'YYYY-MM-DD HH:mm:ss');
  return getCurrentTimeBackground;
};

export const ActiveAppStateFunc = BGTime => {
  const getCurrentTimeactiveBackground = dayjs(new Date(), 'YYYY-MM-DD HH:mm:ss');
  const diffInSeconds = getCurrentTimeactiveBackground.diff(BGTime, 'seconds', true);
  return diffInSeconds;
};

/**
 *
 * @param {*} length  of the request Id
 * @returns the new secret key
 */
export const generateSecreteKey = length => {
  var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
    result = '';
  for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
  return result;
};

/**
 * @param {*} secret is the randomly generated secret key
 * @param {*} id is the id of the api transaction
 * @returns the API request id with the secret key
 */

export const createRequestIds = (id, secret) => {
  var length = Math.floor(Math.random() * 10) + 3;
  var salt = Math.floor(Math.random() * 10) + 4;
  // var id = this.state.id;
  var requestId =
    Math.random()
      .toString(36)
      .substring(2, length) +
    Math.random()
      .toString(36)
      .substring(2, salt) +
    id;

  var secretNew = secret + generateSecreteKey(requestId.length);
  var latestTransaction = {
    requestId: requestId,
    secret: secretNew
  };

  return latestTransaction;
};

/**
 *
 * @param {*} text the value which need to encrypt the object
 * @param {*} secret the randomly generated key to encrypt the object
 * @returns the object which has 2 parts. part1 contains the encrypted payload and
 *   part2 contains the encryption key wrapped with RSA encryption algorithm.
 */



export const encrypt = (text, secret) => {
  try {
    // **RSA Public Key**
    const publicKeyPem = `-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAopjpiwfy7vefTOzf6go5wRsZlgxoBVRbLtxfX9WkgfpvSn0AdSW2c98mQaIbh9zyVFUK+k8DhPdalBVAiiRBd0EU03+5CKpBy0GkCR6JTNhjmJP8AA0PiCdvsbJ2fhkMaBcoMnv/gJspq5G4wm4PLqY3qiSbVxzg9HV4uGeIrNF/ZNysbx0PwOtAUWxii6GQ6wLmtuiH6kCOJ2l8aI0LRqCND8pBaDimyqfJOfc/Rl9Btu4BaRuHjGSll5LEPvEJC+plqHOyKb0efOAaMOqX5V7cJds9xP0zZ8xtY3gYgHg8r5R10o3fJtVAa/VIOlZUuw13tSqUmNnJleKSfa0bPwIDAQAB\n-----END PUBLIC KEY-----`;

    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

    // **Encrypt the secret using RSA-OAEP with SHA-256**
    const encryptedSecret = publicKey.encrypt(secret, 'RSA-OAEP', {
      md: forge.md.sha256.create(), // SHA-256 hash function
      mgf1: forge.mgf1.create(forge.md.sha256.create()), // MGF1 padding with SHA-256
    });

    // **Generate AES Key & IV**
    const salt = CryptoJS.lib.WordArray.random(16);
    const iv = CryptoJS.lib.WordArray.random(16);

    const cryptoKey = CryptoJS.PBKDF2(secret, salt, {
      keySize: 256 / 32,
      iterations: 100,
      hasher: CryptoJS.algo.SHA256,
    });

    // **Encrypt the text using AES-CBC**
    // const encrypted = CryptoJS.AES.encrypt(JSON.stringify(text), cryptoKey, {
    //   iv: iv,
    //   padding: CryptoJS.pad.Pkcs7,
    //   mode: CryptoJS.mode.CBC,
    // });
    const encrypted = CryptoJS.AES.encrypt(
      typeof text === 'string' ? text : JSON.stringify(text),
      cryptoKey,
      {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }
    );


    // **Return Encrypted Data**
    const transitMessage = {
      part1: salt.toString() + iv.toString() + encrypted.toString(),
      part2: forge.util.encode64(encryptedSecret), 
    };

    return transitMessage;
  } catch (e) {
    // console.error('Encryption error:', e);
    return null;
  }
};

// export const encrypt = (text, secret) => {
//   try {
//     var sign = new JSEncrypt();
//     // var public_key =
//     //   // "MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAwHUjXM33DHN/j3EGNu5m+QPl31aQsY+8kJiMfn3JaVIAGC9DpG1rsNdIEcbxwDW44m0r+fS0a4cZ2XjG4CkCoa7Q3OBsbEfu1Ggk7Am/slotn+cWAtIZR0OrcYqbIlodOe5gZhfDGyaAB9x+2WZgPT9qaGQkc4JMZHScdlPSD14RN0Poavc94zpoE0BnmyMQZijyMgssF11PJVX1SBkvJOgDl7GBLEMgkron7mG7X7GR/5+K0F/B9bERLW8DdhzdnzABx/mkjZfWaR2FuPxydoxcTF6KH0MmNJwTSN782GBbWD9bTVfrBSn59Tdp4+ctZ5mnEltANVs+ahS2YaBraXE3PSWoB9hkFp3Y7YkamuNpLX+HRGs5Jh9oq5eJO9ijtkUTjzFMl7Y/Gmuqxof4DvQUpExBLo6yUsgz9m1QuyIZogyM+0vQHv2IswADrAj9I3kvG3iL96VNhz/xdsXcn2bKZLPbpEdG7uu/BR0/BEfFGNdAy2v7cbbsC6kkWGiCA010MWMe3JaFxGKdN0YDY2qGVjzJ5wNgNQp5zjxE763+gr4SHhqe1jgWFNqRuvFYuNLtmxmiKiARIMzyskAUY1AxVZTIA9GugSq8eov0kSouHZOqkmS2VsGYA1g3Qp86+YKRdknuINdOeNegGLEkYkf1p83CI+tRr/xEAy3LZd8CAwEAAQ==";
//     //   'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzOp8NIKioedN6WpdNYNJKqMq4cODPZBx24Rvt/OFzRzTgnCkpRZ/KSEw4Z0fpuxH9PvBns6JRBa6emOe+J5tckse0FWRu/Qj4YWkkp+VSDfxC8XFMOoI6efW4k+sHNmsAyZTDVPMsnFLMKpMkAE9Ef4esmjlv0cPIoLiF4DVP1u3lZGZCFvP3c9A1c8FxOSdbhBb5ScArQqE4RPr04bi+/0zJUKFZkWoPh7dGz8+L+NBwrpwkbBykJXvfiz+yrpPcE2d7w5lPirfmua9iBcJljw9p48fJl48Yu6NPjSBFnYLJrPG871llimxOujVj8cFVLZz8eGWlj4AwHesm4U82QIDAQAB';

//     var publicKeyPem =
//       // "MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAwHUjXM33DHN/j3EGNu5m+QPl31aQsY+8kJiMfn3JaVIAGC9DpG1rsNdIEcbxwDW44m0r+fS0a4cZ2XjG4CkCoa7Q3OBsbEfu1Ggk7Am/slotn+cWAtIZR0OrcYqbIlodOe5gZhfDGyaAB9x+2WZgPT9qaGQkc4JMZHScdlPSD14RN0Poavc94zpoE0BnmyMQZijyMgssF11PJVX1SBkvJOgDl7GBLEMgkron7mG7X7GR/5+K0F/B9bERLW8DdhzdnzABx/mkjZfWaR2FuPxydoxcTF6KH0MmNJwTSN782GBbWD9bTVfrBSn59Tdp4+ctZ5mnEltANVs+ahS2YaBraXE3PSWoB9hkFp3Y7YkamuNpLX+HRGs5Jh9oq5eJO9ijtkUTjzFMl7Y/Gmuqxof4DvQUpExBLo6yUsgz9m1QuyIZogyM+0vQHv2IswADrAj9I3kvG3iL96VNhz/xdsXcn2bKZLPbpEdG7uu/BR0/BEfFGNdAy2v7cbbsC6kkWGiCA010MWMe3JaFxGKdN0YDY2qGVjzJ5wNgNQp5zjxE763+gr4SHhqe1jgWFNqRuvFYuNLtmxmiKiARIMzyskAUY1AxVZTIA9GugSq8eov0kSouHZOqkmS2VsGYA1g3Qp86+YKRdknuINdOeNegGLEkYkf1p83CI+tRr/xEAy3LZd8CAwEAAQ==";
//          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAopjpiwfy7vefTOzf6go5wRsZlgxoBVRbLtxfX9WkgfpvSn0AdSW2c98mQaIbh9zyVFUK+k8DhPdalBVAiiRBd0EU03+5CKpBy0GkCR6JTNhjmJP8AA0PiCdvsbJ2fhkMaBcoMnv/gJspq5G4wm4PLqY3qiSbVxzg9HV4uGeIrNF/ZNysbx0PwOtAUWxii6GQ6wLmtuiH6kCOJ2l8aI0LRqCND8pBaDimyqfJOfc/Rl9Btu4BaRuHjGSll5LEPvEJC+plqHOyKb0efOAaMOqX5V7cJds9xP0zZ8xtY3gYgHg8r5R10o3fJtVAa/VIOlZUuw13tSqUmNnJleKSfa0bPwIDAQAB';
    
//   const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
      
//     // sign.setPublicKey(public_key);
//     // var s = sign.encrypt(secret);
//     var s = publicKey.encrypt(secret, "RSA-OAEP");

//     // Ensure salt and IV are exactly 16 bytes (128 bits)
//     var salt = CryptoJS.lib.WordArray.random(16);
//     var iv = CryptoJS.lib.WordArray.random(16);

//     // Use SHA-256 in PBKDF2 for key derivation
//     var cryptoKey = CryptoJS.PBKDF2(secret, salt, {
//       keySize: 256 / 32, 
//       iterations: 10000, 
//       hasher: CryptoJS.algo.SHA256 
//     });

//     var encrypted = CryptoJS.AES.encrypt(JSON.stringify(text), cryptoKey, {
//       iv: iv,
//       padding: CryptoJS.pad.Pkcs7,
//       mode: CryptoJS.mode.CBC
//     });

//     var transitmessage = {
//       part1: salt.toString() + iv.toString() + encrypted.toString(),
//       part2: forge.util.encode64(s)
//     };

//     return transitmessage;
//   } catch (e) {
//     console.error("Encryption error:", e);
//     return null;
//   }
// };

// export const encrypt = (text, secret) => {
//   try {
//     var sign = new JSEncrypt();
//     // var public_key = '-----BEGIN PUBLIC KEY-----';
//     var public_key =
//       // "MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAwHUjXM33DHN/j3EGNu5m+QPl31aQsY+8kJiMfn3JaVIAGC9DpG1rsNdIEcbxwDW44m0r+fS0a4cZ2XjG4CkCoa7Q3OBsbEfu1Ggk7Am/slotn+cWAtIZR0OrcYqbIlodOe5gZhfDGyaAB9x+2WZgPT9qaGQkc4JMZHScdlPSD14RN0Poavc94zpoE0BnmyMQZijyMgssF11PJVX1SBkvJOgDl7GBLEMgkron7mG7X7GR/5+K0F/B9bERLW8DdhzdnzABx/mkjZfWaR2FuPxydoxcTF6KH0MmNJwTSN782GBbWD9bTVfrBSn59Tdp4+ctZ5mnEltANVs+ahS2YaBraXE3PSWoB9hkFp3Y7YkamuNpLX+HRGs5Jh9oq5eJO9ijtkUTjzFMl7Y/Gmuqxof4DvQUpExBLo6yUsgz9m1QuyIZogyM+0vQHv2IswADrAj9I3kvG3iL96VNhz/xdsXcn2bKZLPbpEdG7uu/BR0/BEfFGNdAy2v7cbbsC6kkWGiCA010MWMe3JaFxGKdN0YDY2qGVjzJ5wNgNQp5zjxE763+gr4SHhqe1jgWFNqRuvFYuNLtmxmiKiARIMzyskAUY1AxVZTIA9GugSq8eov0kSouHZOqkmS2VsGYA1g3Qp86+YKRdknuINdOeNegGLEkYkf1p83CI+tRr/xEAy3LZd8CAwEAAQ==";
//       'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzOp8NIKioedN6WpdNYNJKqMq4cODPZBx24Rvt/OFzRzTgnCkpRZ/KSEw4Z0fpuxH9PvBns6JRBa6emOe+J5tckse0FWRu/Qj4YWkkp+VSDfxC8XFMOoI6efW4k+sHNmsAyZTDVPMsnFLMKpMkAE9Ef4esmjlv0cPIoLiF4DVP1u3lZGZCFvP3c9A1c8FxOSdbhBb5ScArQqE4RPr04bi+/0zJUKFZkWoPh7dGz8+L+NBwrpwkbBykJXvfiz+yrpPcE2d7w5lPirfmua9iBcJljw9p48fJl48Yu6NPjSBFnYLJrPG871llimxOujVj8cFVLZz8eGWlj4AwHesm4U82QIDAQAB';

//     // public_key += 'vclOF1wNDSRdfBV/I5s7GTtDdum4dL2ZdWMvXkh1p2kG8mLQwRN8uleUOhuubhcC';
//     // public_key += '+0y1qFf+xqxt2s21Uq3XddngVHAphbhvsAvY4cBwJa+27z8WCwt2B60OhsL/d+KL';
//     // public_key += '2bTXEaq2CEKYsjlD2QIDAQAB';
//     //public_key += '-----END PUBLIC KEY-----';
//     sign.setPublicKey(public_key);
//     var s = sign.encrypt(secret);
//     var salt = CryptoJS.lib.WordArray.random(128 / 8);
//     var iv = CryptoJS.lib.WordArray.random(128 / 8);
//     var cryptoKey = CryptoJS.PBKDF2(secret, salt, {
//       keySize: 256 / 32,
//       iterations: 100
//     }); /* key */

//     var encrypted = CryptoJS.AES.encrypt(JSON.stringify(text), cryptoKey, {
//       iv: iv,
//       padding: CryptoJS.pad.Pkcs7,
//       mode: CryptoJS.mode.CBC
//     });
//     var transitmessage = {
//       part1: salt.toString() + iv.toString() + encrypted.toString(),
//       part2: s
//     };
//     return transitmessage;
//   } catch (e) {}
// };

/**
 *
 * @param {*} text is the response of the REST API to decrept
 * @param {*} secret is the key of the encryption which needs to pass to get the decrepted value
 * @returns the decrycpted value as object
 */



export const decrypt = (text, secret) => {
  try {
 
    const salt = CryptoJS.enc.Hex.parse(text.substring(0, 32));
    const iv = CryptoJS.enc.Hex.parse(text.substring(32, 64));
    const encryptedText = text.substring(64);

    // Derive key using PBKDF2 with SHA-256
    const key = CryptoJS.PBKDF2(secret, salt, {
      keySize: 256 / 32,
      iterations: 100, 
      hasher: CryptoJS.algo.SHA256
    });

    // Decrypt the encrypted text using AES-CBC
    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });
     
    // Convert decrypted data to a UTF-8 string
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

    // console.log('decryptedText',decryptedText)

    // Parse JSON if valid, else return raw string
    return decryptedText ? JSON.parse(decryptedText) : null;
  } catch (e) {
    // console.error("Decryption error:", e);
    return null;
  }
};


// export const decrypt = (text, secret) => {
//   var key = CryptoJS.PBKDF2(secret, CryptoJS.enc.Hex.parse(text.substr(0, 32)) /* Salt */, {keySize: 256 / 32, iterations: 100});
//   var decrypted = CryptoJS.AES.decrypt(text.substring(64) /* encrypted */, key, {
//     iv: CryptoJS.enc.Hex.parse(text.substr(32, 32)) /* iv */,
//     padding: CryptoJS.pad.Pkcs7,
//     mode: CryptoJS.mode.CBC
//   });
//   //return decrypted.toString(CryptoJS.enc.Hex);
//   return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
// };



export const getTodaysTransDate = validityDate => {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  const dateToday = new Date();
  const date = dateToday.getDate();
  const month = monthNames[dateToday.getMonth()];
  const monthSelected = months[dateToday.getMonth()];
  const year = dateToday.getFullYear();
  if (validityDate) {
    return `${year}-${monthSelected}-${date}`;
  } else {
    return `${date}-${month}-${year}`;
  }
};
// date format November 25, 2024 to 25-Nov-2024
// export const changeDateFormat = value => {
//   const date = new Date(value);
//   const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//   const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${months[date.getMonth()]}-${date.getFullYear()}`;
//   return formattedDate; 
// };
export const changeDateFormat = value => {
  if (!value) return '';
  const months = {
    January: 'Jan', February: 'Feb', March: 'Mar', April: 'Apr', May: 'May', June: 'Jun',
    July: 'Jul', August: 'Aug', September: 'Sep', October: 'Oct', November: 'Nov', December: 'Dec'
  };
  const match = value.trim().match(/^([A-Za-z]+)\s+(\d{1,2}),\s*(\d{4})$/);
  if (match) {
    const [, monthName, day, year] = match;
    return `${day.padStart(2, '0')}-${months[monthName]}-${year}`;
  }
  return '';
};

export const encryptUpload = (text, secret) => {
  try {
    if (typeof secret !== 'string') {
      throw new Error('Secret must be a string. Got: ' + typeof secret);
    }
  const publicKeyPem = `-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAopjpiwfy7vefTOzf6go5wRsZlgxoBVRbLtxfX9WkgfpvSn0AdSW2c98mQaIbh9zyVFUK+k8DhPdalBVAiiRBd0EU03+5CKpBy0GkCR6JTNhjmJP8AA0PiCdvsbJ2fhkMaBcoMnv/gJspq5G4wm4PLqY3qiSbVxzg9HV4uGeIrNF/ZNysbx0PwOtAUWxii6GQ6wLmtuiH6kCOJ2l8aI0LRqCND8pBaDimyqfJOfc/Rl9Btu4BaRuHjGSll5LEPvEJC+plqHOyKb0efOAaMOqX5V7cJds9xP0zZ8xtY3gYgHg8r5R10o3fJtVAa/VIOlZUuw13tSqUmNnJleKSfa0bPwIDAQAB\n-----END PUBLIC KEY-----`;

    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

    const encryptedSecret = publicKey.encrypt(secret, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: forge.mgf1.create(forge.md.sha256.create()),
    });

    const salt = CryptoJS.lib.WordArray.random(16);
    const iv = CryptoJS.lib.WordArray.random(16);

    const cryptoKey = CryptoJS.PBKDF2(secret, salt, {
      keySize: 256 / 32,
      iterations: 100,
      hasher: CryptoJS.algo.SHA256,
    });

    const encrypted = CryptoJS.AES.encrypt(
      typeof text === 'string' ? text : JSON.stringify(text),
      cryptoKey,
      {
        iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }
    );

     const transitMessage={
      part1: salt.toString() + iv.toString() + encrypted.toString(),
      part2: forge.util.encode64(encryptedSecret),
    };
    return transitMessage;

  } catch (e) {

    return null;
  }
};

let id = 0;



export const generateRequestId = () => {
  const secret =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  const requestId = createRequestIds(id, secret);
  id += 1;
  return requestId;
};

export const openLink = url => {
  if (Platform.OS === 'web') {
    window.open(url, '_blank');
  } else {
    if (Platform.OS === 'android') {
      Linking.openURL(url);
    } else {
      SafariView.show({
        url: url,
        tintColor: "#007AFF",
        barTintColor: "#FFFFFF",
      }).catch(error => {
        console.error("Failed to open SafariView:", error);
      });
    }
  }
};

export const generateHTML = (data) => {
  const {logo, playstore, appstore} = base64images;
  return receiptTemplate(data, logo, playstore, appstore);
};

export const downloadNewReceipt = async (response) => {
  const html = generateHTML(response);
  const result = await downloadReceipt({
    html,
    fileName: response?.TrackNumber,
    webMode: 'pdf',
  });
  console.log('Download result:', result);
  return result;
};

export const formatAmountToDecimal = (value) => {
  return /^\d+\.\d{2}$/.test(String(value))
    ? String(value)
    : Number(value).toFixed(2);
}